import { CATALOG_PAGE_SIZE, shouldTriggerCatalogLoadMore } from '../utils/catalogScroll'

export const catalogInfiniteScroll = {
  data() {
    return {
      catalogPageIndex: 0,
      catalogHasMore: true,
    }
  },
  mounted() {
    this._initCatalogScrollObserver()
  },
  beforeUnmount() {
    if (this._catalogScrollObserver) {
      this._catalogScrollObserver.disconnect()
      this._catalogScrollObserver = null
    }
  },
  methods: {
    resetCatalogPagination() {
      this.catalogPageIndex = 0
      this.catalogHasMore = true
    },
    _initCatalogScrollObserver() {
      if (typeof IntersectionObserver === 'undefined') return
      this._catalogScrollObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.loadNextCatalogBatch()
          }
        },
        { root: null, rootMargin: '400px', threshold: 0 }
      )
      this._observeCatalogSentinel()
    },
    _observeCatalogSentinel() {
      this.$nextTick(() => {
        if (!this._catalogScrollObserver) return
        this._catalogScrollObserver.disconnect()
        const el = this.$refs.catalogScrollSentinel
        if (el) {
          this._catalogScrollObserver.observe(el)
        }
      })
    },
    loadNextCatalogBatch() {
      if (this.cargando || !this.catalogHasMore) return
      const nextIndex = this.catalogPageIndex + 1
      this.fetchCatalogPage(nextIndex)
    },
    onCatalogBatchLoaded(pageIndex, batchCount) {
      this.catalogPageIndex = pageIndex
      this.catalogHasMore = batchCount >= CATALOG_PAGE_SIZE
      this._observeCatalogSentinel()
      if (this.catalogHasMore) {
        this.$nextTick(() => {
          if (shouldTriggerCatalogLoadMore(75)) {
            this.loadNextCatalogBatch()
          }
        })
      }
    },
    handleScroll() {
      if (shouldTriggerCatalogLoadMore(75)) {
        this.loadNextCatalogBatch()
      }
    },
  },
}
